import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { apiList } from './apiList.service';
import { receive, receiveResponse, resolveChatCreatedAt } from '../models/chat.model';

@Injectable({
  providedIn: 'root',
})
export class chatService {
  constructor(
    private readonly http: HttpClient,
    private _apiList: apiList,
  ) {}

  getChatsById(id: string, query: string): Observable<receiveResponse> {
    return this.http
      .get<{
        data: receiveResponse;
      }>(`${environment.base_url}${this._apiList.chat}/${id}?${query}`)
      .pipe(
        map(res => ({
          ...res.data,
          list: res.data.list.map(message => this.normalizeHistoryMessage(message)),
        })),
      );
  }

  private normalizeHistoryMessage(message: receive): receive {
    return {
      ...message,
      created_at: resolveChatCreatedAt(message) ?? message.created_at,
    };
  }
}
